<template>
  <!--  [D] LIVE 상세에서만 사용하는 플레이어 영역 -->
    <div class="player-wrap">
      <div class="player" id="player">
        <WebpImage :image-info="{ imageUrl: contentInfo.image, width: 0, height: 0, alt: contentInfo.title, className: 'player-image ' + currentSection }" />
        <div @click.prevent="clickPlayer" class="btn-play"><player class="play-btn"></player></div>
        <div @click.prevent="goBack()" class="player-back-btn">
          <span class="a11y-hidden">뒤로 가기</span>
          <BackButton/>
        </div>
      </div>
    </div>
</template>
<script>
import Meta from '@/components/meta/Meta'
import BackButton from '@/assets/svg/common/ic_gnb_back_w.svg'
import Player from '@/assets/svg/common/ic-player-play-l.svg'
import _ from 'lodash'
import { ATTR_BY_PLAYER_TYPE } from '@/common/player.const'
import WebpImage from '@/components/image/WebpImage'
/**
 * LIVE 에만 적용 되는 구형 레거시 코드
 * LIVE 도 상세 개편 시 GoAppPlayer 로 통일
 * (22/11/16)
 */
export default {
  mixins: [Meta],
  name: 'GoAppPlayerForLive',
  metaInfo () {
    return {
      title: this.metaTitle,
      titleTemplate: '%s : 웨이브'
    }
  },
  props: {
    contentInfo: {
      type: Object
    },
    currentSection: {
      type: String
    },
    clickPlayer: {
      type: Function
    }
  },
  components: {
    BackButton,
    Player,
    WebpImage
  },
  methods: {
    goBack () {
      this.$router.back()
    }
  },
  computed: {
    metaTitle () {
      return _.get(this.contentInfo, ATTR_BY_PLAYER_TYPE[this.currentSection].title, '프로그램 상세화면')
    }
  }
}
</script>
<style>
header {
  width: 100%;
}
.play-container.chrome-fixed{
  position: fixed;
  height: 100vh;
  overflow: hidden;
}
.player {
  position: relative;
  overflow: hidden;
  width: 100%;
  background-color: #252525;
  top: 0;
  left: 0;
  padding-top: 56.25%;
  max-height: 210px;
}
.player::before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 20;
  background-color: rgba(0, 0, 0, 0.3);
}
.player-image {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  height: 100%;
}

.player-back-btn {
  display: -webkit-flex;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 4px;
  left: 4px;
  width: 36px;
  height: 36px;
  z-index: 100;
}
.btn-play {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 36px;
  height: 36px;
  margin-left: -18px;
  margin-top: -18px;
  z-index: 30;
}

.play-event-container a{
  display: block;
}

.play-event-container a img{
  display: block;
  width: 100%;
  max-width: 375px;
  margin: 0 auto;
}
</style>
